import Heart from '../assets/Heart.svg'
import Rating from '../assets/Rating.svg'
import Message from '../assets/Message.svg'

export default function Recommendations() {
    return (
        <div className="mt-20 flex flex-wrap space-y-10 lg:space-y-0 justify-between">
            <iframe className="w-full lg:w-6/12 border rounded-lg"
                width="160"
                height="315"
                src="https://www.youtube.com/embed/8OWB3ifIg9k"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
            <div className="bg-white gold-bg border shadow-md rounded-xl md:px-10 py-14 w-full lg:w-5/12 px-10">
                <p className="font-black text-4xl text-center">100,000+ Gold Users</p>
                <div className="flex mt-6 justify-between">
                    <div className="flex flex-col items-stretch">
                        <p className="text-7xl">4.8</p>
                        <img src={Rating}/>
                        <p>100,000+ Reviews</p>
                    </div>
                    <div className="space-y-10">
                        <div className="flex space-x-3">
                            <img src={Heart} />
                            <div>
                                <p className="font-black">95%</p>
                                <p>Users Satisfied</p>
                            </div>
                        </div>
                        <div className="flex space-x-3">
                            <img src={Message} />
                            <div>
                                <p className="font-black">400,000+</p>
                                <p>Consultations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
